import { PropsWithChildren, useContext } from 'react';
import { StripeLoader } from '@water-web/view';

import { LocaleContext } from '@app/contexts';
import { mapAppLocaleToStripeLocale } from '@app/utils/mapAppLocaleToStripeLocale';

interface LocaleAwareStripeLoaderProps {
  stripeKey: string;
}

export const LocaleAwareStripeLoader = (props: PropsWithChildren<LocaleAwareStripeLoaderProps>) => {
  const { locale } = useContext(LocaleContext);
  const stripeLocale = mapAppLocaleToStripeLocale(locale);

  return (
    <StripeLoader stripeKey={props.stripeKey} locale={stripeLocale}>
      {props.children}
    </StripeLoader>
  );
};
